module.exports = __webpack_public_path__ + "img/carousel-3.4f9dd3b8.png";